import { jsx as _jsx } from "react/jsx-runtime";
import { breakpoints, pxToRems, } from '@awaze/design-system.utils.react';
import styled, { css } from 'styled-components';
import createTheme from 'styled-variants';
const colourSchemes = ({ theme }) => ({
    light: {
        borderColor: `${theme.ColorWhiteOpacity20}`,
    },
    dark: {
        borderColor: `${theme.ColorGrey100}`,
    },
});
const borderThickness = (isVertical, thickness, breakpointIndex) => {
    let borderWidth = 1;
    if (typeof thickness === 'number') {
        borderWidth = thickness;
    }
    if (Array.isArray(thickness)) {
        borderWidth = thickness[breakpointIndex];
    }
    return isVertical
        ? `border-width: 0 ${borderWidth}px 0 0;`
        : `border-width: ${borderWidth}px 0 0 0;`;
};
const DividerTheme = createTheme('Divider').addVariant('colourScheme', colourSchemes);
const DividerThemed = styled.hr(DividerTheme);
const DividerStyled = styled(DividerThemed) `
  ${({ isVertical, margin, thickness }) => (isVertical &&
    css `
        ${borderThickness(isVertical, thickness, 0)}
        border-style: solid;
        min-height: 100%;
        margin: 0 ${pxToRems(margin * 0.75)};

        @media screen and (min-width: ${breakpoints[0]}px) {
          margin: 0 ${pxToRems(margin)};
          ${borderThickness(isVertical, thickness, 1)}
        }

        @media screen and (min-width: ${breakpoints[1]}px) {
          ${borderThickness(isVertical, thickness, 2)}
        }
      `) ||
    css `
      ${borderThickness(isVertical, thickness, 0)}
      border-style: solid;
      margin: ${pxToRems(margin * 0.75)} 0;

      @media screen and (min-width: ${breakpoints[0]}px) {
        margin: ${pxToRems(margin)} 0;
        ${borderThickness(isVertical, thickness, 1)}
      }
      @media screen and (min-width: ${breakpoints[1]}px) {
        ${borderThickness(isVertical, thickness, 2)}
      }
    `}
`;
/**
 * A divider for separating content on the page.
 *
 * Renders a horizontal or vertical line as a 'hr' or 'div' tag with the 'separator' role.
 */
export const Divider = ({ colourScheme = 'dark', isVertical, margin, className, thickness = 1, ...rest }) => {
    let dividerMargin;
    if (typeof margin === 'number') {
        dividerMargin = margin;
    }
    else {
        dividerMargin = isVertical ? 16 : 32;
    }
    return (_jsx(DividerStyled, { colourScheme: colourScheme, isVertical: isVertical, margin: dividerMargin, as: isVertical ? 'div' : 'hr', "aria-orientation": isVertical ? 'vertical' : 'horizontal', role: "separator", className: className, thickness: thickness, ...rest }));
};
//# sourceMappingURL=divider.js.map